import * as React from 'react';
import { PrimaryButtonTracked } from 'components/shared';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkPriceLockup, UitkPriceLockupAlign } from 'uitk-react-price-lockup';
import { UitkCardAloha, UitkCardAlohaContentSection } from 'uitk-react-cards';
import { UitkSheetFooter } from 'uitk-react-sheet';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';
import { AnalyticsConfig } from 'uitk-react-utils';

interface FlexibleSearchGridFooterProps {
  analytics: AnalyticsConfig;
  buttonText: string;
  dateText: string;
  onClick?: () => void;
  priceText: string;
  subText: string;
}

export const FlexibleSearchGridFooter = ({
  analytics,
  buttonText,
  dateText,
  onClick,
  priceText,
  subText
}: FlexibleSearchGridFooterProps) => (
  <UitkSheetFooter>
    <UitkCardAloha>
      <UitkCardAlohaContentSection>
        <UitkSpacing padding="one">
          <UitkLayoutGrid justifyContent="space-between" columns={2}>
            <UitkLayoutGridItem>
              <div>
                <UitkText size={300}>{dateText}</UitkText>
                <UitkPriceLockup
                  a11yPrice={`${priceText} ${subText}`}
                  align={UitkPriceLockupAlign.LEFT}
                  lockupPrice={priceText}
                  priceSubtextFirst={subText}
                />
              </div>
            </UitkLayoutGridItem>
            <UitkLayoutGridItem justifySelf="end">
              <UitkSpacing margin={{ block: 'three' }}>
                <PrimaryButtonTracked text={buttonText} onClick={onClick} analytics={analytics} />
              </UitkSpacing>
            </UitkLayoutGridItem>
          </UitkLayoutGrid>
        </UitkSpacing>
      </UitkCardAlohaContentSection>
    </UitkCardAloha>
  </UitkSheetFooter>
);

FlexibleSearchGridFooter.displayName = 'FlexibleSearchGridFooter';
